<template>
  <CRow>
    <CCol col="12" lg="6">
      <CCard no-header>
        <CCardBody>
          <h3>
            {{$t('Membership.AddMembership')}}
          </h3>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>

            <CInput :label="$t('Membership.Title')" type="text" v-model="subscription.title"></CInput>

            <CInput :label="$t('Membership.Price')" type="number" v-model="subscription.price"></CInput>

            <CInput :label="$t('Membership.Description')" type="text" v-model="subscription.description"></CInput>

            <CInput :label="$t('Membership.Duration')" type="number" v-model="subscription.delete_item_after"></CInput>

          <CButton color="success" @click="store()" class="w-100">{{$t('Button.Add')}}</CButton>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>

import {subscriptionService} from "../../_services";
export default {
  name: 'EditUser',
  props: {
    caption: {
      type: String,
      default: 'User id'
    },
  },
  data: () => {
    return {
        subscription: {
          title: '',
          price: 0,
          description: '',
          delete_item_after: 5,
        },
        product_types: [],
        providers: [],
        message: '',
        dismissSecs: 7,
        dismissCountDown: 0,
        showDismissibleAlert: false,
        last_batch_id: ''
    }
  },
  methods: {
    setUpRef(){
      let type = this.product_types.find(x => x.value === this.batch.product_type_id).label;
      let type_chars = type.match(/\b(\w)/g); // ['J','S','O','N']
      type_chars = type_chars.join(''); // JSON

      let provider = this.providers.find(x => x.value === this.batch.provider_id).label;
      let provider_chars = provider.match(/\b(\w)/g); // ['J','S','O','N']
      provider_chars = provider_chars.join(''); // JSON

      this.batch.reference = type_chars+'-'+provider_chars+'-'+(this.last_batch_id+1)
    },
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    store() {
      this.loader = this.$loading.show();
      let form = new FormData();
      form.append("title", this.subscription.title);
      form.append("price", this.subscription.price);
      form.append("description", this.subscription.description);
      form.append("delete_item_after", this.subscription.delete_item_after);

      subscriptionService
        .create(form)
        .then(
          function(data) {
            this.$toast.success("Produit créé avec succès");
            this.message = "added successfully";
            this.showAlert();
            this.goBack();
          }.bind(this)
        )
        .finally(
          function() {
            this.loader.hide();
          }.bind(this)
        );
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
  },
  mounted(){
  }
}

</script>
